import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Textarea, Tooltip, Typography } from "@mui/joy";
import React, { useState, useEffect, useContext } from "react"
import { AlertContext } from '../../context/AlertFlag';
import { copyToClipboard } from '../../utils/Clipboard';
import { capitalizeWords } from '../../utils/FormatNoteNameAndText';
import PropTypes from "prop-types";

function NoteDisplayCard({noteTitles, noteText, parentEditable, assignRefs}) {
    const { addAlert } = useContext(AlertContext);

    const [titles, setTitles] = useState([]);
    const [parts, setParts] = useState([]);
    const [editable, setEditable] = useState(false);
    

    useEffect( () => {
        setTitles(noteTitles);
        setParts(noteText);
        setEditable(parentEditable);
    }, [parentEditable, noteTitles])

    // Can look for better way to handle current system
    // Aggressively clean -> Deallocate dynamic references at lowest and highest level to mark collection for garbage collector
    useEffect(() => {
        return () => {
          assignRefs.forEach((ref, i) => {
            if (ref?.current) {
              assignRefs[i].current = null;
            }
          });
        };
    }, []);
      
    return <>
        {(titles.map((title, index) => {
            return <div key={`${title} ${index}`}>
             <div style={{marginBottom: '4px', display: "flex"}}>
                <Typography level="body-lg" sx={{alignSelf: "center", m: 0, fontSize: '1.125rem'}}>
                    {capitalizeWords(title.toLowerCase(), ' ')}
                </Typography>
                {!editable && <Tooltip title="Copy section" size="sm">
                    <IconButton onClick={() => {
                        addAlert("Section Copied!", "success")
                        copyToClipboard(parts[index]);
                        }} sx={{ width: "fit-content", alignSelf: "center"}}>
                        <ContentCopyIcon fontSize="lg"/>
                    </IconButton>
                </Tooltip>}
            </div>
            <Textarea
            key={`textarea-${index}`}
            defaultValue={parts[index]}
            slotProps={{ textarea: { ref: assignRefs[index] } }}
            variant="plain"
            size="sm"
            sx={{ backgroundColor: "white" }}
            readOnly={editable ? false : true}
            />
            </div>
        })
        )}
    </>
}

NoteDisplayCard.propTypes = {
    noteTitles: PropTypes.arrayOf(PropTypes.string).isRequired,
    noteText: PropTypes.arrayOf(PropTypes.string).isRequired,
    parentEditable: PropTypes.bool.isRequired,
    assignRefs: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export function formattedText(soapString, setTitles, setRefs, assignRefs, editable, setParts) {
    const text=`Ensure start ${soapString}`;
    let match;
    const titles = [];
    const regex = /\*\*([^*]+)\*\*/g;
    let parts = [];

    while ((match = regex.exec(text)) !== null) {
        titles.push(match[1]);
    }
    setTitles(titles);

    let lastIndex = 0;
    let refsIndex = 0;
    for (let i = 0; i < titles.length; i++) {
        const title = titles[i];
        const index = text.indexOf(`**${title}**`, lastIndex) - 1;
        if (index !== -1) {
            parts.push(text.substring(lastIndex, index).trim());
            setRefs(refsIndex);
            refsIndex += 1;
            lastIndex = index + title.length + 6; 
        }
    }

    // Add the last part of the text
    if (lastIndex < text.length) {
        parts.push(text.substring(lastIndex).trim());
        setRefs(refsIndex);
    }

    // Remove start
    parts = parts.slice(1);
    setParts(parts);
    return <NoteDisplayCard noteText={parts} noteTitles={titles} assignRefs={assignRefs} parentEditable={editable}/>
}

export function pureTitleAndParts(noteUnformatted) {
    const text=`Ensure start ${noteUnformatted}`;
    let match;
    const titles = [];
    const regex = /\*\*([^*]+)\*\*/g;
    let parts = [];


    while ((match = regex.exec(text)) !== null) {
        titles.push(match[1]);
    }

    let lastIndex = 0;
    for (let i = 0; i < titles.length; i++) {
        const title = titles[i];
        const index = text.indexOf(`**${title}**`, lastIndex) - 1;
        if (index !== -1) {
            parts.push(text.substring(lastIndex, index).trim());
            lastIndex = index + title.length + 6; 
        }
    }

    // Add the last part of the text
    if (lastIndex < text.length) {
        parts.push(text.substring(lastIndex).trim());
    }

    // Remove start
    parts = parts.slice(1);

    return {
        "titles": titles,
        "parts": parts
    }
}